import React from 'react';
import { Listing, core_apimessages_ShippingMethod as IShippingMethod } from '../gql/graphql';
import { ListingOfferMetadata } from './listing_offer_metadata';
import { shippingPriceDataForMethod, getReturnPolicyDays } from '@reverbdotcom/commons/src/listing_helpers';
import { listingItemPageMetaDataUrl } from './helpers/metadata_helper';

export interface ListingCardReviews {
  count: number;
  averageRating: number;
}

interface Props {
  listing: Listing;
  reviews?: ListingCardReviews;
  hideMetadataAsOffer?: boolean;
  includeItemListMetadata?: boolean;
}

// TODO: This method will be removed and use the metadatahelper in a more generic way without the dependency of the CSP 
export function ReviewMetadata( { reviews } : { reviews: ListingCardReviews } ) {
  const totalReviews = reviews.count;
  if (!totalReviews) return null;

  return (
    <div
      itemProp="aggregateRating"
      itemScope
      itemType="http://schema.org/AggregateRating"
    >
      <meta itemProp="ratingValue" content={reviews.averageRating.toString()} />
      <meta itemProp="bestRating" content="5" />
      <meta itemProp="worstRating" content="1" />
      <meta itemProp="reviewCount" content={totalReviews.toString()} />
    </div>
  );
}

export function ItemListMetadata({ listing } : { listing: Listing }) {
  return (
    <>
      <meta itemProp="name" content={listing.title || ''} />
      <meta itemProp="image" content={(listing?.images?.length && listing?.images[0]?.source) || ''} />
      <meta itemProp="url" content={listingItemPageMetaDataUrl(listing)} />
    </>
  );
}

export function ListingCardMetadata({ 
  listing, 
  reviews = undefined, 
  hideMetadataAsOffer = false,
  includeItemListMetadata = false,
}: Props) {

  return (
    <>
      {includeItemListMetadata && <ItemListMetadata listing={listing} />}
      {reviews && <ReviewMetadata reviews={reviews} />}
      {!hideMetadataAsOffer && (
        <ListingOfferMetadata
          listing={listing}
          shippingData={shippingPriceDataForMethod(listing, IShippingMethod.SHIPPED)}
          returnPolicyDays={getReturnPolicyDays(listing)}
        />
      )}
    </>
  );
}
